import axios from "axios";

// axios.defaults.baseURL = '/api'
const myAxios = axios.create({
  baseURL: "http://cangduobao.com/api/",
  // baseURL: "http://cangduobao.com/api/",
  // baseURL: "http://192.168.0.164/api/",
});

// 导出axios
export default myAxios;
